import { orgInviteUrl } from '../urls';
import refresh from '../refresh';

export async function getOrgInvites(orgId) {
  return refresh(async () => {
    const response = await fetch(`${orgInviteUrl}?${new URLSearchParams({
      org: orgId,
    })}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}

export async function postOrgInvite(orgId, email) {
  const data = {
    org: orgId,
    email,
  };
  return refresh(async () => {
    const response = await fetch(orgInviteUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}

export async function deleteOrgInvite(orgId, email) {
  const data = {
    org: orgId,
    email,
  };
  return refresh(async () => {
    const response = await fetch(orgInviteUrl, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
